var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2009 7.20061H8.80103V0.800562C8.80103 0.359058 8.44258 0.000610352 8.00093 0.000610352C7.55942 0.000610352 7.20098 0.359058 7.20098 0.800562V7.20061H0.800928C0.359424 7.20061 0.000976562 7.55906 0.000976562 8.00056C0.000976562 8.44221 0.359424 8.80066 0.800928 8.80066H7.20098V15.2006C7.20098 15.6422 7.55942 16.0007 8.00093 16.0007C8.44258 16.0007 8.80103 15.6422 8.80103 15.2006V8.80066H15.2009C15.6426 8.80066 16.001 8.44221 16.001 8.00056C16.001 7.55906 15.6426 7.20061 15.2009 7.20061V7.20061Z",
    fill: "currentcolor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.000976562 0.000610352)"
  })))));
}

export default SvgPlus;